import { Link } from 'react-router-dom'
import { ArrowRight, TrendingUp } from 'lucide-react'
import { formatVND } from '@/lib/formatters'
import type { TopProduct } from '../../model/types'

export function TopProductsList({ products }: { products: TopProduct[] }) {
  const maxSold = Math.max(...products.map((p) => p.sold), 1)
  return (
    <div className="bg-surface border border-border rounded-xl shadow-card overflow-hidden">
      <div className="px-5 h-14 border-b border-border flex items-center justify-between">
        <h3 className="font-semibold text-text inline-flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-brand-600" /> Sản phẩm bán chạy
        </h3>
        <Link to="/admin/san-pham" className="text-sm text-brand-600 hover:underline inline-flex items-center gap-1 font-medium">
          Tất cả <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <ul className="divide-y divide-border">
        {products.map((p, i) => (
          <li key={p.id} className="px-5 py-3 flex items-center gap-3">
            <span className={[
              'w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold shrink-0',
              i === 0 ? 'bg-amber-100 text-amber-700'
                : i === 1 ? 'bg-slate-200 text-slate-700'
                : i === 2 ? 'bg-orange-100 text-orange-700'
                : 'bg-brand-50 text-brand-700',
            ].join(' ')}>
              {i + 1}
            </span>

            <div className="w-10 h-10 rounded-md overflow-hidden bg-slate-100 border border-border shrink-0">
              <img
                src={p.image}
                alt={p.name}
                className="w-full h-full object-contain"
                onError={(e) => {
                  (e.target as HTMLImageElement).src =
                    'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"><rect width="1" height="1" fill="%23e2e8f0"/></svg>'
                }}
              />
            </div>

            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-text line-clamp-1">{p.name}</div>
              <div className="mt-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
                <div className="h-full bg-gradient-to-r from-brand-600 to-brand-400 transition-all" style={{ width: `${(p.sold / maxSold) * 100}%` }} />
              </div>
            </div>

            <div className="text-right shrink-0">
              <div className="text-sm font-bold text-text">{p.sold} đã bán</div>
              <div className="text-[11px] text-muted">{formatVND(p.revenue)}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
